import { z } from 'zod';

export const environmentSchema = z.object({
  apiUrl: z.string(),
  auth: z.object({
    url: z.string(),
    clientId: z.string(),
    grantType: z.string(),
    realm: z.string(),
    audience: z.string(),
  }),
  googleMapsApiKey: z.string(),
  isDevelopment: z.boolean(),
});

const env = {
  apiUrl: process.env.REACT_APP_API_URL,
  auth: {
    url: process.env.REACT_APP_AUTH_URL,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    grantType: process.env.REACT_APP_AUTH_GRANT_TYPE,
    realm: process.env.REACT_APP_AUTH_REALM,
    audience: process.env.REACT_APP_AUTH_AUDIENCE,
  },
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  isDevelopment: process.env.REACT_APP_ENVIRONMENT === 'development',
};

export const environment = environmentSchema.parse(env);
